module.exports = __webpack_public_path__ + "static/media/SellerboxMain01.5c39b00a.png";